// Adapted from CollapsableGroup on https://www.mypremieronline.com/help-center/internet.html

import * as $ from 'jquery';
import { Analytics } from '@plaudit/analytics';

export default class Accordion {
	public wrapperEl: string = '.accordion';
	public $wrapperEl: JQuery = $(this.wrapperEl);
	private className_item: string = 'accordion';
	private selector_triggerClassName: string = 'accordion__link';
	private selector_triggerSpanClassName: string = 'accordion__linkText';
	private selector_trigger: string = '.' + this.selector_triggerClassName;
	private selector_triggerSpan: string = '.' + this.selector_triggerSpanClassName;
	private selector_target: string = '.accordion__content';
	private analytics: Analytics;
	private accordionMinHeight: number = 200;
	private accordionSpaceAboveLink: number = 30;
	private animationDuration: number = 250;

	private getLocationHash() {
		const value = window.location.hash;
		return value;
	}
	private escapeId(id: string) {
		const value = id.replace(/([\.\:])/, '\\$1');
		return value;
	}
	private getIdFromHash(id: string) {
		const value = id.substr(1);
		return value;
	}
	private toggleItem(element: Element, force?: boolean): void {
		const $element = $(element);
		const isOpen = $element.parent().hasClass('target');

		if (!$element.parent().data('originalHeight')) {
			$element.parent().data('originalHeight', $element.outerHeight() + this.accordionSpaceAboveLink);
		}

		if (!isOpen) {
			this.analytics.trackEvent('Accordion', 'Expand');
		}
		if (isOpen) {
			$element.parent().removeClass('target');
			$element.parent().stop(true).animate({height: this.accordionMinHeight}, this.animationDuration);
			$element.find(this.selector_triggerSpan).text('Keep Reading');
		} else {
			$element.parent().addClass('target');
			$element.parent().stop(true).animate({height: $element.parent().data('original-height')}, this.animationDuration);
			$element.find(this.selector_triggerSpan).text('Close');
		}
	}
	public toggleItemTargeted(): void {
		const locationHash = this.escapeId(this.getLocationHash());
		if (locationHash) {
			const $targetedElement = $(this.wrapperEl + locationHash);
			
			if ($targetedElement) {
				this.toggleItem($targetedElement.find(this.selector_trigger).get(0));
			}
		}
	}
	private setupEventHandlers(): void {
		this.$wrapperEl.on('click', this.selector_trigger, (event: JQueryMouseEventObject) => {
			event.preventDefault();
			history.replaceState(undefined, undefined, location.pathname + "#" + $(event.currentTarget).closest(this.wrapperEl).attr('id'));
			this.toggleItem(event.currentTarget);
		});
	}

	constructor() {
		if (!this.$wrapperEl) {
			return;
		}
		this.analytics = Analytics.getInstance();
		this.setupEventHandlers();
		this.$wrapperEl.addClass('ready');

		var goo = () => {
			$(this.selector_target).each((index, element) => {
				if ($(element).outerHeight() > this.accordionMinHeight) {
					$(element).data('original-height', $(element).outerHeight() + this.accordionSpaceAboveLink);
					$(element).append(`<button class="${this.selector_triggerClassName}"><span class="${this.className_item}__linkIcon"></span><span class="${this.selector_triggerSpanClassName}">Keep Reading</span></button>`);
					$(element).animate({height: this.accordionMinHeight}, this.animationDuration);
				}
			});
		};

		$.when( goo() ).done(() => {
			this.toggleItemTargeted();
		});
	}
}
